<template>
  <div id="show-carousel">
    <div :id="`show-swiper-${carouselId}`" class="swiper-container">
      <div class="swiper-wrapper">
        <div v-for="image in images"
             :key="image.id"
             class="swiper-slide"
        >
          <picture class="swiper-slide__thumb-container">
            <img
              class="swiper-slide__thumb-container__thumb"
              :src="$router.options.imagePath + image.urlMedia"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper, { Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
Swiper.use(Autoplay);

export default {
  name: 'ShowCarousel',
  props: {
    images: {
      type: Array,
      required: true
    },
    carouselId: {
      type: String,
      required: false,
      default: () => Date.now().toString()
    }
  },

  data() {
    return {
      swiperConfig: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        grabCursor: true,
        loop: true,
        simulateTouch: true
      }
    };
  },

  mounted() {
    new Swiper(`#show-swiper-${this.carouselId}`, this.swiperConfig);
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/abstracts/_variables.scss';
div#show-carousel {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  @include media-breakpoint-down(lg) {
    position: relative;
  }
}
.swiper-container {
  height: 100%;
  .swiper-slide {
    &__thumb-container {
      display: block;
      position: relative;
      padding-top: 100%;
      @include media-breakpoint-up(lg) {
        padding-top: calc(100vh - 80px);
      }
      &__thumb {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.2s ease;
        object-position: 50% 50%;
      }
    }
  }
}
</style>
